import { IMG_CRAFT, IMG_NATURE_KIDS, PHOTO_LEAVES, PHOTO_MERMAID, PHOTO_PIRATE_SHIP, PHOTO_NICHE } from "@/lib/assets";

// Easy to edit: add / remove / update workshops here.
export const WORKSHOPS = [
  {
    id: "arts-recup",
    img: IMG_CRAFT,
    day: { fr: "Mercredi", en: "Wednesday" },
    title: { fr: "Arts & Récup'", en: "Arts & Upcycling" },
    age: "6–11",
    duration: { fr: "2h", en: "2h" },
    desc: { fr: "Peinture, collage et création à partir de matériaux recyclés.", en: "Painting, collage and creating from recycled materials." },
    spots: 6,
    available: true,
  },
  {
    id: "explorateurs-nature",
    img: IMG_NATURE_KIDS,
    day: { fr: "Samedi", en: "Saturday" },
    title: { fr: "Petits Explorateurs Nature", en: "Little Nature Explorers" },
    age: "4–8",
    duration: { fr: "2h30", en: "2h30" },
    desc: { fr: "Découverte du littoral, cabane et trésors de la nature.", en: "Discovering the coast, dens and nature's treasures." },
    spots: 6,
    available: true,
  },
  {
    id: "land-art",
    img: PHOTO_LEAVES,
    day: { fr: "Mercredi", en: "Wednesday" },
    title: { fr: "Land Art & Trésors", en: "Land Art & Treasures" },
    age: "6–11",
    duration: { fr: "2h", en: "2h" },
    desc: { fr: "Composer des œuvres éphémères avec feuilles, coquillages et bois flotté.", en: "Create ephemeral art with leaves, shells and driftwood." },
    spots: 6,
    available: true,
  },
  {
    id: "contes-lagon",
    img: PHOTO_MERMAID,
    day: { fr: "Samedi", en: "Saturday" },
    title: { fr: "Contes du Lagon", en: "Lagoon Tales" },
    age: "3–6",
    duration: { fr: "1h30", en: "1h30" },
    desc: { fr: "Histoires, jeux d'eau et imaginaire au bord du lagon.", en: "Stories, water games and imagination by the lagoon." },
    spots: 6,
    available: true,
  },
  {
    id: "aventure-pirates",
    img: PHOTO_PIRATE_SHIP,
    day: { fr: "Mercredi", en: "Wednesday" },
    title: { fr: "Aventure Pirates", en: "Pirate Adventure" },
    age: "5–9",
    duration: { fr: "2h", en: "2h" },
    desc: { fr: "Chasse au trésor, cartes et défis d'équipage.", en: "Treasure hunt, maps and crew challenges." },
    spots: 6,
    available: false,
  },
  {
    id: "eveil-creatif",
    img: PHOTO_NICHE,
    day: { fr: "Samedi", en: "Saturday" },
    title: { fr: "Éveil créatif", en: "Creative Awakening" },
    age: "4–8",
    duration: { fr: "2h", en: "2h" },
    desc: { fr: "Petites enquêtes, manipulation et projets collectifs.", en: "Little investigations, hands-on play and group projects." },
    spots: 6,
    available: true,
  },
];
